/**
 * @packageDocumentation
 * @module @simplewebauthn/browser
 * @preferred
 */
import startAttestation from './methods/startAttestation';
import startAssertion from './methods/startAssertion';
import supportsWebauthn from './helpers/supportsWebauthn';

export { startAttestation, startAssertion, supportsWebauthn };
